import { Connector } from '@web3-react/types'
import {
    coinbaseWalletConnection,
    ConnectionType,
    gnosisSafeConnection,
    injectedConnection,
    networkConnection,
    walletConnectConnection,
} from './connection'

export function getIsInjected(): boolean {
    return Boolean(window.ethereum)
}

export function getIsMetaMask(): boolean {
    return window.ethereum?.isMetaMask ?? false
}

export function getIsCoinbaseWallet(): boolean {
    return window.ethereum?.isCoinbaseWallet ?? false
}

const CONNECTIONS = [
    gnosisSafeConnection,
    injectedConnection,
    coinbaseWalletConnection,
    walletConnectConnection,
    networkConnection,
]
export function getConnection(c: Connector | ConnectionType) {
    if (c instanceof Connector) {
        const connection = CONNECTIONS.find((connection) => connection.connector === c)
        if (!connection) {
            throw Error('unsupported connector')
        }
        return connection
    } else {
        switch (c) {
            case ConnectionType.INJECTED:
                return injectedConnection
            case ConnectionType.COINBASE_WALLET:
                return coinbaseWalletConnection
            case ConnectionType.WALLET_CONNECT:
                return walletConnectConnection
            case ConnectionType.NETWORK:
                return networkConnection
            case ConnectionType.GNOSIS_SAFE:
                return gnosisSafeConnection
        }
    }
}

export function getConnectionName(connectionType: ConnectionType, isMetaMask?: boolean) {
    switch (connectionType) {
        case ConnectionType.INJECTED:
            return isMetaMask ? 'MetaMask' : 'Browser Wallet'
        case ConnectionType.COINBASE_WALLET:
            return 'Coinbase Wallet'
        case ConnectionType.WALLET_CONNECT:
            return 'WalletConnect'
        case ConnectionType.NETWORK:
            return 'Network'
        case ConnectionType.GNOSIS_SAFE:
            return 'Gnosis Safe'
    }
}

export const getWalletType = (connector: Connector | ConnectionType) =>
    getConnectionName(getConnection(connector).type, getIsMetaMask())
